import { Controller } from '@hotwired/stimulus'
import { createRoot } from 'react-dom/client'
import { createElement } from 'react'
import { components } from '../react/registry'

export default class extends Controller {
  static values = {
    component: String,
    props: Object,
  }

  connect() {
    const Component = components[this.componentValue]

    if (!Component) {
      console.warn(`[react-controller] Unknown component: ${this.componentValue}`)
      return
    }

    this.root = createRoot(this.element)
    this.root.render(createElement(Component, this.propsValue))
  }

  disconnect() {
    if (this.root) {
      this.root.unmount()
      this.root = null
    }
  }
}
